import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppFloat from './WhatsAppFloat';
import '../styles/site.css';

export default function PublicLayout() {
  return (
    <div className="site">
      <Navbar />
      <div className="site__body">
        <Outlet />
      </div>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
